<template>
  <v-card>
  <v-container fluid class="px-0 pt-0">
  <v-card>
  <form ref="form"
  v-model="valid"
  lazy-validation>
      <v-row class="px-2">
      <v-col cols="12" sm="6" md="3">
          <v-menu v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          >
          <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="editedItem.start_dt"
                  label="Fecha de Turno Desde"
                  prepend-icon="mdi-calendar-today"
                  :rules="fechaRule"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
          </template>
          <v-date-picker v-model="editedItem.start_dt" @input="menu = false"></v-date-picker>
          </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-menu v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          >
          <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="editedItem.end_dt"
                  label="Fecha de Turno Hasta"
                  prepend-icon="mdi-calendar-today"
                  :rules="fechaRule"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
          </template>
          <v-date-picker v-model="editedItem.end_dt" @input="menu2 = false"></v-date-picker>
          </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
          <v-autocomplete v-model="editedItem.ApiPunto"
          :items="oppoint"
          :item-text="'OpPoint_Description'"
          :item-value="'OpPoint_id'"
          label="Centro"
          multiple
          ></v-autocomplete>
       </v-col>
       <v-col cols="12" sm="6" md="3">
          <v-autocomplete v-model="editedItem.TurningStorageArea"
          :items="TurningStorageArea"
          :item-text="'TurningStorageArea_Desc'"
          :item-value="'TurningStorageArea_Desc'"
          label="Almacen"
          multiple
          ></v-autocomplete>
       </v-col>
       <v-col cols="12" sm="6" md="3">
          <v-btn :disabled="btn" color="primary" @click="submit">Buscar</v-btn>
        </v-col>
      </v-row>
    </form>
    <v-spacer></v-spacer>
    </v-card>
    </v-container>
    <v-container fluid class="px-0">
      <v-card>
       <v-card-title>
         <v-icon x-large>mdi-clipboard-list-outline</v-icon>Planning
         <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Filtro"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      :items="mvm"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
    <template v-slot:item.action="{ item }">
      <v-tooltip bottom>
       <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          class="mr-2"
          v-bind="attrs"
          v-on="on"
          @click="viw_detail(item)"
        >
          mdi-eye
        </v-icon>
        </template>
        <span>Ver Detalle</span>
        </v-tooltip>
      </template>
    </v-data-table>
    </v-card>
    </v-container>
    <v-spacer></v-spacer>
   <v-card class="py-2 px-2">
      <template>
      <div class="d-flex justify-space-around">
          <v-btn type="button" color="primary" @click="onexport" class="mx-4">Descargar Planning</v-btn>
          <v-btn type="button" color="primary" @click="cargaModificacion">Cargar Modif. Parcial</v-btn>
      </div>
      </template>
   </v-card>
    <v-dialog v-model="dialog_detail" max-width="1000px">
    <v-card>
              <v-card-title>
                <span class="headline">Detalle</span>
              </v-card-title>
  
              <v-card-text>
                <v-container>
                <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.TurningStorageArea_Desc"
                          label="Almacen"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.OpPoint_id"
                          label="Punto"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.VendorPurchaseOrder_Num"
                          label="OC"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.Section_Description"
                          label="Sección"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field :disabled="true" type="text" v-model="this.Supplier_Description"
                          label="Proveedor"  required></v-text-field>
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.RequestProposal_Dt"
                          label="Fecha Emisión"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.Reception_Dt"
                          label="Fecha Entrega"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.Closing_Dt"
                          label="Fecha Cierre"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field :disabled="true" type="text" v-model="this.CDay_id"
                          label="Fecha Turno"  required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field :disabled="true" type="text" v-model="this.CHour_Description"
                          label="Hora Turno"  required></v-text-field>
                      </v-col>
                  </v-row>
    <v-data-table
      :headers="headers2"
      :items="tdetalle_vew"
      :search="search2"
      sort-by="ProductBarCode_id"
      class="elevation-1"
    >
    </v-data-table>
                  </v-container>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close2">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_new" max-width="900px">
    <v-stepper v-model="e1" vertical>
           <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
          <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Buscando Pedidos
              <small>Consultando Turnos del {{this.editedItem.start_dt}} hasta {{this.editedItem.end_dt}}</small>
          </v-stepper-step>
          <v-stepper-content step="1">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>
  
          <v-stepper-step :complete="e1 > 2" step="2" :rules="[value => !! step_error2]" :color="step_color2">Buscando Referencias
              <small>Consultando detalle de los Turnos encontrados del {{this.editedItem.start_dt}} hasta {{this.editedItem.end_dt}}</small>
          </v-stepper-step>
          <v-stepper-content step="2">
          <v-card height="100px">
              <div class="text-center">
              <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
              {{this.msj_proceso}}
              </div>
          </v-card>
          </v-stepper-content>
          
      </v-stepper>
    </v-dialog>
    <v-dialog v-model="dialog_carga" max-width="900px">
              <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
              </v-overlay>
              <v-card>
                  <v-card-title>
                      <span class="headline">Carga Modificacion Parcial</span>
                  </v-card-title>
  
                  <v-card-text>
                      <v-file-input
                          show-size
                          counter
                          v-model="file"
                          accept=".xlsx"
                          :loading="loadingCarga"
                          label="Ingrese Archivo"
                      ></v-file-input>
                  </v-card-text>
  
                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="close">Cancelar</v-btn>
                      <v-btn :disabled="loadDisabled || file == null" color="accent" text @click="loadFile">Cargar</v-btn>
						          <!-- <v-btn v-if="isPreProd" :disabled="loadDisabled || file == null" color="accent" text @click="queueJob">Cargar en cola de procesamiento</v-btn> -->
                  </v-card-actions>
              </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog_load" max-width="400" persistent>
            <v-card color="blue-grey darken-3" dark>
              <div v-if="!invalidHeaders">
                <v-card-title class="headline">Cantidades Procesadas</v-card-title>
                <v-card-text class="text-h6">Filas omitidas: {{ rowsOmmited }}</v-card-text>
                <v-card-text class="text-h6">Filas con mal formato: {{ rowsBadFormat }}</v-card-text>
                <v-card-text class="text-h6">Filas con monto superior al límite: {{ rowsExceeded }}</v-card-text>
                <v-card-text class="text-h6">Filas Ok: {{ rowsOk }}</v-card-text>
                <div v-if="noRows">
                  <v-card-subtitle>No hay filas para procesar</v-card-subtitle>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                      <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn>
                  </v-card-actions>
                </div>
                <div v-if="!noRows">
                  <div style="display:flex; justify-content:center" v-if="!processComplete">
                    <v-progress-circular model-value="20" indeterminate class="mx-2"></v-progress-circular><span>Aguarde mientras se procesa la solicitud</span>
                  </div>
                  <div style="display:flex; justify-content:center" v-else-if="processComplete">
                    <span style="text-align:center; padding: 5px">{{msj_completo}}</span>
                  </div>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                      <v-btn color="primary" @click="dialog_load=false" :disabled="!processComplete">Cerrar</v-btn>
                  </v-card-actions>
                </div>
              </div>
              <div v-else-if="invalidHeaders">
                <v-card-subtitle>Las cabeceras del archivo no concuerdan con los esperados.</v-card-subtitle>
                <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog_load=false">Cerrar</v-btn>
                </v-card-actions>
              </div>
              
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialogDownloading" persistent max-width="300px">
              <v-card>
                <v-card-title class="headline">Descargando...</v-card-title>
                <v-card-text>Por favor, espere mientras se prepara la descarga del archivo.</v-card-text>
                <v-progress-linear indeterminate color="primary"></v-progress-linear>
              </v-card>
            </v-dialog>
  
        </v-card>
  </template>
  
  <script>
  import axios from 'axios'
  //import Vue from "vue";
  //import JsonExcel from "vue-json-excel";
  import XLSX from 'xlsx';
   
  //Vue.component("downloadExcel", JsonExcel);
  
  export default {
    data: () => ({
      search: '',
      search2: '',
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      dialog: false,
      dialog_pass: false,
      dialog_new: false,
      dialog_detail: false,
      dialog_carga: false,
      dialog_load: false,
      valid: true,
      menu: false,
      menu2: false,
      e1: 0,
      btn: false,
      msj_proceso:'',
      msj_completo: '',
      progressBar1: false,
      progressBar: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      TurningStorageArea_Desc:'',
      OpPoint_id: '',
      Supplier_Description:'',
      VendorPurchaseOrder_Num:'',
      Section_Description:'',
      RequestProposal_Dt: '',
      Reception_Dt: '',
      Closing_Dt:'',
      Comment_Txt:'',
      CDay_id:'',
      CHour_Description:'',
      file: null,
      loadingCarga: false,
      loadDisabled: false,
      rowsOmmited: 0,
      rowsBadFormat: 0, 
      rowsExceeded: 0,
      rowsOk: 0,
      invalidHeaders: false,
      processComplete: false,
      noRows: false,
      headers: [
        { text: 'Actions', value: 'action', sortable: false },      
        { text: 'ID Almacen', value: 'TurningStorageArea_id' },
        { text: 'Almacen', value: 'TurningStorageArea_Desc' },
        { text: 'Punto', value: 'OpPoint_id' },
        { text: 'OC', value: 'VendorPurchaseOrder_Num' },
        { text: 'Prov', value: 'Supplier_id' },
        { text: 'R Social', value: 'Supplier_Description' },
        { text: 'Seccion', value: 'Section_Description'},
        { text: 'Fecha Emisión', value: 'RequestProposal_Dt'},
        { text: 'Fecha Entrega', value: 'Reception_Dt' },
        { text: 'Fecha Cierre', value: 'Closing_Dt' },
        { text: 'Observación', value: 'Comment_Txt' },
        { text: 'Fecha de turno', value: 'CDay_id' },
        { text: 'Hora De Turno', value: 'CHour_Description' },
        { text: 'Bultos pedidos', value: 'qty_bu'},
        { text: 'Pallets Pedidos', value: 'qty_pa'},
        { text: 'Cantidad de Referencias', value: 'qty_line'}
      ],
      headers2: [
        { text: 'Ean', value: 'ProductBarCode_id' },
        { text: 'Desc', value: 'ProductBarCode_Description' },
        { text: 'Med', value: 'MeasureUnit_id' },
        { text: 'PCB', value: 'ProductPack_Qty' },
        { text: 'Btos x pallet', value: 'Pallet_Qty' },
        { text: 'Bul Ped', value: 'RequestPack_Qty'},
        { text: 'Pallets', value: 'RequestPallet_Qty'},
        { text: 'Tipo de frío', value: 'ColdType_Desc' },
        { text: 'Tipo Entrega', value: 'DeliveryType_Desc' },
        { text: 'Tipo Camion', value: 'TruckType_Desc' }
      ],
      dialogDownloading: false,
      mvm: [],
      tdetalle: [],
      oppoint: [{ OpPoint_id: '', OpPoint_Description: '-Todos' }],
      TurningStorageArea: [{ TurningStorageArea_id: '', TurningStorageArea_Desc: '-Todos' }],
      tdetalle_vew: [],
      ApiUserSupplier:[],
      editedIndex: -1,
      editedItem: {
        start_dt: new Date().toISOString().substr(0, 10),
        end_dt: new Date().toISOString().substr(0, 10),
        ApiPunto: '',
        TurningStorageArea: [ '-Todos' ]
      },
      defaultItem: {
        start_dt: new Date().toISOString().substr(0, 10),
        end_dt: new Date().toISOString().substr(0, 10),
        ApiPunto: '',
        TurningStorageArea: ['-Todos' ]
      },
      fechaRule: [
          v => !!v || 'Fecha es requerida'
      ],
      puntoRules: [
          v => !!v || 'Centro es Requerida',
          v => (v && v != -1.0) || 'Centro no Valida'
      ],
      TurningStorageAreaRules: [
          v => !!v || 'Almacen es Requerido',
          v => (v && v != -1.0) || 'Almacen no Valido'
      ],
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
  
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Planning' : 'Editar Planning'
      },
      isPreProd() {
        const host = window.location.hostname
        if (host.includes('localhost') || host.includes('10.22.178.89')) {
          return true 
        }
        return false
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
  
    created () {
      this.initialize()
    },
  
    methods: {
      initialize () {
        this.overlay = true
        axios.post(this.api_tool_url + '/get_ApiUserSupplier', {ApiUser_id:this.$store.state.ApiUser_id}, this.config)
          .then(response => { 
              response.data.ResultRows.forEach(info => {
              this.ApiUserSupplier.push(info.MotherSupplier_Desc)
              })
          })
          .catch(error => {
            this.ApiUserSupplier = []
            alert(error.response.data.message)
          }),
  
          axios.post(this.api_tool_url + '/get_oppoint_P', {}, this.config)
          .then(response => {
              this.oppoint = response.data.ResultRows
              this.oppoint.push({ OpPoint_id: '', OpPoint_Description: '-Todos' })
          })
          .catch(error => {
            this.oppoint = []
            alert(error.response.data.message)
          }),
  
          axios.post(this.api_tool_url + '/get_turningstoragearea2', {}, this.config)
          .then(response => {
              this.TurningStorageArea = response.data.ResultRows
              this.TurningStorageArea.push({ TurningStorageArea_id: '', TurningStorageArea_Desc: '-Todos' })
              this.overlay = false
          })
          .catch(error => {
            this.TurningStorageArea = []
            alert(error.response.data.message)
          })
      },
      viw_detail(item){
        const index = this.mvm.indexOf(item)
        let tmpmvm = item
        this.dialog_detail=true
        this.progressBar1=true
        this.TurningStorageArea_Desc = tmpmvm.TurningStorageArea_Desc
        this.OpPoint_id = tmpmvm.OpPoint_id
        this.Supplier_Description = tmpmvm.Supplier_Description
        this.VendorPurchaseOrder_Num = tmpmvm.VendorPurchaseOrder_Num
        this.Section_Description = tmpmvm.Section_Description
        this.RequestProposal_Dt = tmpmvm.RequestProposal_Dt
        this.Reception_Dt = tmpmvm.Reception_Dt
        this.Closing_Dt = tmpmvm.Closing_Dt
        this.Comment_Txt = tmpmvm.Comment_Txt
        this.CDay_id = tmpmvm.CDay_id
        this.CHour_Description = tmpmvm.CHour_Description
        this.tdetalle_vew=[]
        
        this.tdetalle_vew = this.tdetalle.filter(function(item) {
          return item.RequestProposal_id == tmpmvm.RequestProposal_id
        })
      },
      submit () {
        this.btn = true
        this.dialog_new = true
        this.e1 = 1
        this.progressBar = true
        this.step_error1= true
        this.step_error2= true
        this.step_error3= true
        this.step_color1="primary",
        this.step_color2="primary",
        this.step_color3="primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        let filter = null
        filter = {start_dt : this.editedItem.start_dt, end_dt: this.editedItem.end_dt, ApiPunto:this.editedItem.ApiPunto,TurningStorageArea:this.editedItem.TurningStorageArea, Supplier:this.ApiUserSupplier, RequestProposal_Dt:""}
        axios.post(this.api_tool_url + '/get_planning_new',filter, this.config)
            .then(response => {
              
              if(response.data.ResultRows.length >= 1)
              {
                  this.mvm = response.data.ResultRows
                  this.e1 = 2
                  this.step_color1 = "#008000"
                  this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
                  axios.post(this.api_tool_url + '/get_planning_detail_new', filter, this.config)
                  .then(response => {
                      if(response.data.ResultRows.length >= 1)
                      {
                          this.e1 = 3
                          this.step_color2 = "#008000"
                          this.tdetalle = response.data.ResultRows
                      }
                      else{
                          this.progressBar = false
                          this.msj_proceso = "No se encontro detalle."
                          this.step_error2 = false
                          this.step_error3 = false
                      }
                  })
                  .catch(error => {
                      this.td = []
                      this.btn = false
                      this.step_error2 = false
                      this.progressBar = false
                      this.msj_proceso = error.response.data.message
                  })
              }
              else{
                  this.progressBar = false
                  this.msj_proceso = "No se encontraron turnos."
                  this.step_error1 = false
                  this.step_error2 = false
                  this.step_error3 = false
              }
              this.btn = false
            })
            .catch(error => {
              this.mvm = []
              this.btn = false
              this.step_error1 = false
              this.progressBar = false
              this.msj_proceso = error.response.data.message
            })
      },
  
      close () {
        this.dialog_new = false
        this.dialog_carga = false
      },
      close2 () {
        this.dialog_detail= false
      },
  
      cargaModificacion () {
        // console.log("carga modificacion parcial")
        this.dialog_carga = true
        this.file = null
        this.loadingCarga = false
        this.loadDisabled = false
      },
  
      loadFile() {
  this.noRows = false;
  this.invalidHeaders = false;
  this.processComplete = false;
  this.dialog_load = false;
  this.overlay = true;

  if (this.file != null) {
    let data = [];
    const reader = new FileReader();
    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const ws = wb.Sheets['Detalle'];
      data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      /* Filtro filas vacías */
      data = data.filter(subArr => subArr.length > 0);

      /* Validacion de headers */
      let headers = data[0];

      /* Valores de archivo */
      const requiredHeaders = ['Almacen Id', 'Almacen', 'Punto', 'OC', 'Prov', 'R Social', 'Seccion', 'Estado', 'F Ped', 
      'F Ent', 'F Vto', 'F Rec', 'Observacion', 'Ean', 'Desc', 'Med', 'PCB', 'Btos x pallet', 'Bultos a Modificar', 
      'Bul Ped ultimo valor', 'Bul Ped valor tabla', 'Pallets', 'Fecha Turno', 'Hora Turno', 'Tipo de frío', 'Marca Id', 
      'Marca Descripcion'];

      let validHeaders = requiredHeaders.every(header => headers.includes(header));

      if (!validHeaders) {
        this.dialog_load = true;
        this.invalidHeaders = true;
        this.overlay = false;
        return;
      }

      let idxBulModif = headers.indexOf('Bultos a Modificar');
      let idxBulOrig = headers.indexOf('Bul Ped valor tabla');
      let idxBulUltimo = headers.indexOf('Bul Ped ultimo valor');
      let idxSection = headers.indexOf('Seccion');
      let idxTipoEntrega = headers.indexOf('Tipo Entrega');
      let idxTipoCamion = headers.indexOf('Tipo Camion');
      let rowsTotal = data.filter((row, index) => index !== 0);

      let idxHeaders = [];
      idxHeaders.push(headers.indexOf('Almacen Id'));
      idxHeaders.push(headers.indexOf('Punto'));
      idxHeaders.push(headers.indexOf('OC'));
      idxHeaders.push(headers.indexOf('Prov'));
      idxHeaders.push(headers.indexOf('Ean'));
      idxHeaders.push(headers.indexOf('Bultos a Modificar'));

      let cantOmitidos = 0;
      let cantFormatoError = 0;
      let cantExcedidos = 0;
      let cantOk = 0;
      let regExp = /[a-zA-Z]/g;
      let rowsComplete = [];
      rowsTotal.map((row) => {
        let hasBulModif = row[idxBulModif] !== undefined && !(regExp.test(row[idxBulModif]));
        let hasTipoEntrega = idxTipoEntrega !== -1 && row[idxTipoEntrega] !== undefined && row[idxTipoEntrega] !== '';
        let hasTipoCamion = idxTipoCamion !== -1 && row[idxTipoCamion] !== undefined && row[idxTipoCamion] !== '';

        if (row[idxSection] === 'CARNICERIA') {
          rowsComplete.push(row); // Todas las filas de la sección CARNICERIA se procesan sin restricciones
        } else if (hasBulModif || hasTipoEntrega || hasTipoCamion) {
          if (!hasBulModif && (hasTipoEntrega || hasTipoCamion)) {
            row[idxBulModif] = row[idxBulUltimo]; // Asignar 'Bul Ped ultimo valor' a 'Bultos a Modificar'
            hasBulModif = true;
          }
          if (hasBulModif) {
            if (row[idxBulModif] <= row[idxBulOrig]) {
              rowsComplete.push(row);
            } else {
              cantExcedidos += 1;
            }
          } else {
            rowsComplete.push(row);
          }
        } else if (row[idxBulModif] === undefined) {
          cantOmitidos += 1;
        } else {
          cantFormatoError += 1;
        }
      });

      cantOk = rowsComplete.length;
      let newRow = [];
      let rows = [];

      rowsComplete.map((row) => {
        newRow = [];
        idxHeaders.map((idx) => {
          if (idx == headers.indexOf('Ean')) {
            let eanStr = String(row[idx]).trim(); // Quitar los espacios en blanco para los strings.
            if (eanStr.startsWith('0')) {
              newRow.push(eanStr); // Ean que tiene 0 por delante
            } else {
              let eanStrWCero = eanStr.padStart(14, '0');
              newRow.push(eanStrWCero); // Ean que tiene 0 por delante
            }
          } else {
            newRow.push(row[idx]);
          }
        });

        newRow.push(idxTipoEntrega !== -1 ? row[idxTipoEntrega] : null);
        newRow.push(idxTipoCamion !== -1 ? row[idxTipoCamion] : null);

        rows.push(newRow);
      });

      this.rowsOmmited = cantOmitidos;
      this.rowsBadFormat = cantFormatoError;
      this.rowsExceeded = cantExcedidos;
      this.rowsOk = cantOk;
      this.dialog_load = true;

      let filter = {
        file: rows,
        email: this.$store.state.ApiUser_EMail,
        user: sessionStorage.getItem('ApiUser_id'),
        type: 'Prov'
      };

      let rowsNonEmpty = rows.filter(row => row.some((cell, idx) => {
        if (idx === idxTipoEntrega || idx === idxTipoCamion) {
          return true; 
        }
        return cell !== null && cell !== undefined && cell !== '';
      }));

      if (rowsNonEmpty.length > 0) {
        axios.post(this.api_tool_url + '/fileUpload_PartialModif_Nuevo', filter, this.config)
          .then(response => {
            // console.log(response.data.ResultRows);
            if (response.data.status === "OK") {
              this.msj_completo = 'Solicitud procesada.'
              this.processComplete = true;
              this.loadingCarga = false;
              this.overlay = false;
              setTimeout(this.close, 5000);
            }
          })
          .catch(error => {
            let errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.toString();
            // console.log(errorMessage);
            alert("Error: " + errorMessage);
            this.processComplete = true;
            this.loadingCarga = false;
            this.overlay = false;
            setTimeout(this.close, 5000);
          });
      } else {
        this.processComplete = true;
        this.noRows = true;
        this.overlay = false;
      }
    };

    reader.readAsBinaryString(this.file);
  } else {
    alert("Debe ingresar un archivo");
    this.overlay = false;
  }
  },
   async queueJob() {
	  this.noRows = false;
	  this.invalidHeaders = false;
	  this.processComplete = false;
	  this.dialog_load = false;
	  this.overlay = true;

	  try {
		const result = await this.fileValidation(this.file); // Cambiado para reutilizar la validación en la carga normal

		if (result.invalidHeaders) {
		  this.invalidHeaders = true;
		  this.dialog_load = true;
		  this.overlay = false;
		  return;
		}

		this.rowsOmmited = result.stats.rowsOmmited;
		this.rowsBadFormat = result.stats.rowsBadFormat;
		this.rowsExceeded = result.stats.rowsExceeded;
		this.rowsOk = result.stats.rowsOk;
		this.dialog_load = true;

		if (result.rowsNonEmpty.length === 0) {
		  this.processComplete = true;
		  this.noRows = true;
		  this.overlay = false;
		  alert("Debe ingresar un archivo");
		  return;
		}

		let filter = {
		  file: result.rows,
		  email: this.$store.state.ApiUser_EMail,
		  user: sessionStorage.getItem('ApiUser_id'),
		  type: 'Prov'
		};

		const response = await axios.post(this.api_tool_url + '/queue_job',filter,this.config);

    if (response.data.status === "OK") {
      // console.log("Job enviado:", response.data.job_id);
      this.msj_completo = 'Archivo encolado. Pronto recibirá la confirmación por mail.'
      this.processComplete = true;
      this.loadingCarga = false;
      this.overlay = false;
      setTimeout(this.close, 5000);
    }else{
      alert("Error: " + response.data.message);
      this.processComplete = true;
      this.loadingCarga = false;
      this.overlay = false;
      setTimeout(this.close, 5000);
    }

	  } catch (error) {
		// console.log(error);
	  } finally {
		this.overlay = false;
		this.loadingCarga = false;
	  }
	},

  
		fileValidation(file) {
			return new Promise((resolve, reject) => {
			if (!file) {
			  return reject("Debe ingresar un archivo");
			}

			const reader = new FileReader();

			reader.onload = (e) => {
			  try {
				let data = [];

				/* Parseo data */
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, { type: "binary" });
				const ws = wb.Sheets['Detalle'];
				/* Convertir a array de arrays */
				data = XLSX.utils.sheet_to_json(ws, { header: 1 });

				/* Filtro filas vacías */
				data = data.filter(subArr => subArr.length > 0);

				/* Validacion de headers */
				let headers = data[0];

				  /* Valores de archivo */
				 const requiredHeaders = ['Almacen Id', 'Almacen', 'Punto', 'OC', 'Prov', 'R Social', 'Seccion', 'Estado', 'F Ped','F Ent', 'F Vto', 'F Rec', 'Observacion', 'Ean', 'Desc', 'Med', 'PCB', 'Btos x pallet', 'Bultos a Modificar','Bul Ped ultimo valor', 'Bul Ped valor tabla', 'Pallets', 'Fecha Turno', 'Hora Turno', 'Tipo de frío', 'Marca Id', 'Marca Descripcion'];

				let validHeaders = requiredHeaders.every(h => headers.includes(h));

				if (!validHeaders) {
				  return resolve({
					invalidHeaders: true
				  });
				}

				let idxBulModif = headers.indexOf('Bultos a Modificar');
				let idxBulOrig = headers.indexOf('Bul Ped valor tabla');
				let idxBulUltimo = headers.indexOf('Bul Ped ultimo valor');
				let idxSection = headers.indexOf('Seccion');
				let idxTipoEntrega = headers.indexOf('Tipo Entrega');
				let idxTipoCamion = headers.indexOf('Tipo Camion');

				let rowsTotal = data.slice(1);

				let idxHeaders = [
				  headers.indexOf('Prop. Pedido id'),
				  headers.indexOf('Num. Linea'),
				  headers.indexOf('Almacen Id'),
				  headers.indexOf('Punto'),
				  headers.indexOf('OC'),
				  headers.indexOf('Prov'),
				  headers.indexOf('Ean'),
				  headers.indexOf('Bultos a Modificar')
				];

				let cantOmitidos = 0;
				let cantFormatoError = 0;
				let cantExcedidos = 0;

				let regExp = /[a-zA-Z]/g;
				let rowsComplete = [];

				rowsTotal.forEach(row => {
				  let hasBulModif = row[idxBulModif] !== undefined && !(regExp.test(row[idxBulModif]));
				  let hasTipoEntrega = idxTipoEntrega !== -1 && row[idxTipoEntrega];
				  let hasTipoCamion = idxTipoCamion !== -1 && row[idxTipoCamion];

				  if (row[idxSection] === 'CARNICERIA') {
					rowsComplete.push(row);  // Todas las filas de la sección CARNICERIA se procesan sin restricciones
				  } else if (hasBulModif || hasTipoEntrega || hasTipoCamion) {
					if (!hasBulModif && (hasTipoEntrega || hasTipoCamion)) {
					  row[idxBulModif] = row[idxBulUltimo]; // Asignar 'Bul Ped ultimo valor' a 'Bultos a Modificar'
					  hasBulModif = true;
					}

					if (hasBulModif) {
					  if (row[idxBulModif] <= row[idxBulOrig]) {
						rowsComplete.push(row);
					  } else {
						cantExcedidos++;
					  }
					} else {
					  rowsComplete.push(row);
					}
				  } else if (row[idxBulModif] === undefined) {
					cantOmitidos++;
				  } else {
					cantFormatoError++;
				  }
				});

				let rows = rowsComplete.map(row => {
				  let newRow = idxHeaders.map(idx => {
					if (idx === headers.indexOf('Ean')) {
					  let ean = String(row[idx]).trim(); // Quitar los espacios en blanco para los strings.
					  return ean.startsWith('0') ? ean : ean.padStart(14, '0'); // Si ean que tiene 0 por delante, traer ean, sino relleno con 0
					}
					return row[idx]; 
				  });

				  newRow.push(idxTipoEntrega !== -1 ? row[idxTipoEntrega] : null);
				  newRow.push(idxTipoCamion !== -1 ? row[idxTipoCamion] : null);

				  return newRow;
				});

				let rowsNonEmpty = rows.filter(row =>
				  row.some((cell, idx) =>
					idx === idxTipoEntrega || idx === idxTipoCamion
					  ? true // Ignorar validación para columnas opcionales
					  : cell !== null && cell !== undefined && cell !== ''
				  )
				);

				resolve({
				  rows,
				  rowsNonEmpty,
				  stats: {
					rowsOmmited: cantOmitidos,
					rowsBadFormat: cantFormatoError,
					rowsExceeded: cantExcedidos,
					rowsOk: rowsComplete.length
				  },
				  invalidHeaders: false
				});

			  } catch (err) {
				reject(err);
			  }
			};

			reader.readAsBinaryString(file);
			});
		},

    
 
      // Nuevo metodo
      onexport () { // On Click Excel download button
          this.dialogDownloading = true;
          const fileName_data ='Planning_desde_'+this.editedItem.start_dt+'_hasta_'+this.editedItem.end_dt+'.xlsx';
          const resumen_data = this.mvm;
          const detalle_data = this.tdetalle;
  
          //console.log('API URL:', this.api_tool_url);
          //console.log('Headers:', this.config);
  
          axios.post(this.api_tool_url +`/exportExcelPlanning`, {
              resumen: resumen_data,
              detalle: detalle_data,
              fileName: fileName_data,
              typeFile: 'Prov'
          }, {
              headers: this.config.headers,
              responseType: 'blob'
          })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName_data);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.dialogDownloading = false;
          })
          .catch(error => {
              console.error('Error generating Excel file:', error);
              this.dialogDownloading = false;
          });
      }
    }
  }
  </script>
  



// WEBPACK FOOTER //
// src/components/PlanningProvGridNew.vue